module.exports = __webpack_public_path__ + "img/dashboard-alt.6d9b853b.svg";